import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import Detail from "@/pages/detail/page";
import Special from "@/pages/special/page";
import Search from "@/pages/search/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/category/:categoryId", element: <Category /> },
      { path: "/detail/:videoId", element: <Detail /> },
      { path: "/special/:specialId", element: <Special /> },
      { path: "/search", element: <Search /> },
      { path: "/about", element: <About /> },
    ],
  },
  { path: "*", element: <NotFound /> },
];

export default routes;